import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box,Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import { TooltipIcon } from 'common/components/TooltipIcon';

export interface WarningMessageWithCheckboxAcknowledgementProps {
    /**
     * Whether to show the warning. Set to true when the user has no active identity.
     */
    show: boolean;

    /**
     * Whether the user has checked the acknowledgment checkbox.
     */
    checked: boolean;

    /**
     * Callback when the checkbox value changes.
     */
    onCheckedChange: (checked: boolean) => void;

    /**
     * The warning message.
     */
    warningMessage: string;

    /**
     * The checkbox label.
     */
    checkboxLabel: string;

    /**
     * Optional tooltip description to display on hover over an info icon.
     */
    tooltipDescription?: string;

    /**
     * Optional test ID for the checkbox element.
     */
    checkboxTestId?: string;
}

export function WarningMessageWithCheckboxAcknowledgement({
    show,
    checked,
    onCheckedChange,
    warningMessage,
    checkboxLabel,
    tooltipDescription,
    checkboxTestId = 'acknowledge-checkbox'
}: Readonly<WarningMessageWithCheckboxAcknowledgementProps>) {
    if (!show) {
        return null;
    }

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Typography variant="body2" color="text.secondary">
                    {warningMessage}
                </Typography>
                {tooltipDescription && (
                    <TooltipIcon
                        IconComponent={InfoOutlinedIcon}
                        tooltipTitle={tooltipDescription}
                        iconColor="action"
                        iconSize="medium"
                    />
                )}
            </Box>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            data-testid={checkboxTestId}
                            checked={checked}
                            onChange={(event) => onCheckedChange(event.target.checked)}
                        />
                    }
                    label={
                        <Typography variant="body2" gutterBottom component="div">
                            {checkboxLabel}
                        </Typography>
                    }
                />
            </FormGroup>
        </>
    );
}
